import { useEffect } from "react";

/** Matches dark tokens in `src/styles/theme.css` [data-theme="dark"]. */
const META_THEME_COLOR = "#0f1210";

function applyDarkTheme() {
  const root = document.documentElement;
  root.dataset.theme = "dark";
  root.style.colorScheme = "dark";
  const meta = document.getElementById("theme-color-meta");
  if (meta) {
    meta.setAttribute("content", META_THEME_COLOR);
  }
}

/**
 * Applies the fixed dark "Vista" gallery theme on mount. The site commits to the
 * cinematic dark look so full-bleed photography carries the design; a manual
 * light/dark toggle can be layered on later if desired.
 */
export function useDayNightTheme() {
  useEffect(() => {
    applyDarkTheme();
  }, []);
}
